const Play = () => import('@/play/play.vue')
export default {
    path: '/play',
    component: Play,
}